module.exports = __webpack_public_path__ + "static/media/tier-10.373edc04.jpg";